<template>
  <div class="more-action__container" :key="iIdx" ref="targetElement">
    <div class="more-action-icon-extend" @click.stop="toggleItem" v-click-outside="clickOutside">
      <lego-icon without-pointer :size="16" icon-type="df" icon="more" class="move-action__icon" />
    </div>
    <teleport to="body">
      <div v-if="showItem" class="more-action-menu" :style="menuPosition">
        <lego-dropdown-menu
          :items="items"
          :isItemShowing="showItem"
          @click="clickItem"
        ></lego-dropdown-menu>
      </div>
    </teleport>
  </div>
</template>

<script setup>
import { computed, defineProps, nextTick, onMounted, onUnmounted, ref } from 'vue';
import legoDropdownMenu from '@/components/lego/extend/legoDropdownMenu.vue';
import legoEventBus from '@/lego-component/utils/eventBus/eventBus';
//props
const emits = defineEmits(['click']);
const props = defineProps({
  item: {
    type: Object,
    default: {}
  },
  items: {
    type: Array,
    default: []
  },
  position: {
    type: String,
    default: 'left'
  },
  border: {
    type: String,
    default: '1px solid #2c5ad8'
  },
  iIdx: {
    type: Number
  }
});
const showItem = ref(false);
const targetElement = ref(null);
const _chartWidth = ref(176);
const _chartHeight = ref(92);
const menuPosition = computed(() => handleMenuPosition());

const handleMenuPosition = () => {
  let anchorStyle = { width: `${_chartWidth.value}px`, height: `${_chartHeight.value}px` };
  if (showItem.value) {
    const bodyRect = document.body.getBoundingClientRect();
    const targetRect = targetElement.value && targetElement.value.getBoundingClientRect();
    if (bodyRect.y + bodyRect.height - targetRect.y < _chartHeight.value + targetRect.height) {
      anchorStyle.top = `calc(${targetRect.top}px - ${_chartHeight.value}px)`;
      anchorStyle.left = `calc(${targetRect.left}px + ${targetRect.width}px - ${_chartWidth.value}px - ${bodyRect.left}px)`;
    } else {
      anchorStyle.top = `calc(${targetRect.top}px + ${targetRect.height}px)`;
      anchorStyle.left = `calc(${targetRect.left}px + ${targetRect.width}px - ${_chartWidth.value}px - ${bodyRect.left}px)`;
    }
  }
  return anchorStyle;
};
const count = ref(0);

onMounted(() => {
  nextTick(() => {
    legoEventBus.$on('click-outside', (key) => clickOutside(key));
    window.addEventListener('resize', setMenuPosition);
  });
});

onUnmounted(() => {
  legoEventBus.$off('click-outside', () => clickOutside());
  window.removeEventListener('resize', setMenuPosition);
});

const setMenuPosition = () => {
  menuPosition.value = handleMenuPosition();
};

const clickOutside = (key) => {
  if (key !== props.iIdx) {
    showItem.value = false;
  }
};
const toggleItem = (e) => {
  emits('click', props.item);
  legoEventBus.$emit('click-outside', props.iIdx);
  showItem.value = !showItem.value;
};
const clickItem = (item) => {
  if (item.action && typeof item.action === 'function') {
    item.action(item, props.item);
  }
  showItem.value = false;
};
const vClickOutside = {
  beforeMount: function (el, binding) {
    const handler = (e) => {
      if (!el.contains(e.target) && el !== e.target) {
        binding.value(e);
      }
    };
    el.__vueClickOutside__ = handler;
    document.addEventListener('click', handler);
    const container = document.body.querySelector('.c-container');
    const simpleBarContent = container && container.querySelector('.simplebar-content-wrapper');
    if (simpleBarContent) {
      simpleBarContent.addEventListener('scroll', handler);
    }
  },
  unmounted: function (el, binding) {
    document.removeEventListener('click', el.__vueClickOutside__);
    el.__vueClickOutside__ = null;
  }
};
</script>

<style scoped lang="scss">
.more-action__container {
  display: flex;
  justify-content: center;
}

.more-action-menu {
  z-index: 1003;
  position: absolute;
  background-color: rgba(255, 255, 255, 1);
  border: none;
}

.more-action-icon {
  position: relative;
  width: 31px;
  height: 31px;
  cursor: pointer;

  .move-action {
    &__icon {
      width: 100%;
      height: 32px;
      border-radius: 3px;
      border: v-bind(border);
    }
  }
}

:deep(.lego-dropdown-menu) {
  border-color: #2c5ad8;
  border-radius: 4px;

  .lego-dropdown__items {
    .lego-dropdown__item {
      color: #2e3138;

      &:hover {
        background-color: #eef2fc;
      }

      .lego-dropdown__label {
        height: 30px;
        min-height: 30px;
      }

      &.lego-dropdown__disabled {
        .lego-dropdown__label {
          opacity: 1;
          color: #b3b7c1;
        }
      }
    }
  }
}
</style>
